import interceptor from 'services/interceptor';

interface SasTokenResponse {
  token: string;
  expiration: string;
}

let sasToken: string | null = null;
let tokenExpiration: Date | null = null;

export async function getSasTokenAsync(): Promise<string> {
  if (!sasToken || (tokenExpiration && new Date() > tokenExpiration)) {
    const sasResponse = await interceptor.apiWithAuth.get<SasTokenResponse>(
      '/storage/get-sas-token-async'
    );

    sasToken = sasResponse.data.token;
    tokenExpiration = new Date(sasResponse.data.expiration);
  }
  return sasToken;
}

// export async function fetchSasTokenIfNeeded(): Promise<void> {
//   if (!sasToken || (tokenExpiration && new Date() > tokenExpiration)) {
//     sasToken = await getSasTokenAsync();
//   }
// }

// export function getCurrentSasToken(): string | null {
//   return sasToken;
// }

// export function getSasTokenSync(): Promise<string> {
//   return new Promise((resolve, reject) => {
//     if (sasToken && tokenExpiration && new Date() <= tokenExpiration) {
//       resolve(sasToken);
//     } else {
//       interceptor.apiWithAuth
//         .get<SasTokenResponse>('/storage/get-sas-token-sync')
//         .then(sasResponse => {
//           sasToken = sasResponse.data.token;
//           tokenExpiration = new Date(sasResponse.data.expiration);
//           resolve(sasToken);
//         })
//         .catch(error => {
//           reject(error);
//         });
//     }
//   });
// }
